@if (activeView() && hardshipService.payload()) {
  @let eventName = hardshipDetailsViews[activeView()].eventName;
  @let isSubmitStep = activeView() === 'hardship_submit_application';
  <bw-action-article-legacy [brightsideWebFb]="{ event_name: eventName}">
    <ui-nav-exit-back
      back-action-top
      [trackingDetail]="{ event_name: eventName}"
    ></ui-nav-exit-back>

    <div content-section>
      <section class="align-left">
        <p title-medium class="mb-sm">{{ hardshipDetailsViews[activeView()].titleKey | uppercase | translate }}</p>
        @if (hardshipDetailsViews[activeView()].descriptionKey) {
          <typography-legacy text-large-regular color="var(--secondary-text)">
            <p class="left" style="max-width: 432px">
              {{ hardshipDetailsViews[activeView()]?.descriptionKey | uppercase | translate }}
            </p>
          </typography-legacy>
        }
      </section>

      <section class="mt-sm">
        <bw-cell-legacy
          [leftLabelColor]="'--secondary-text'"
          [labelLeft]="'HARDSHIP_DETAILS_DATE_REQUESTED' | translate"
          [labelRight]="hardshipService.payload().createdDate | date"
        >
        </bw-cell-legacy>
        <bw-cell-legacy
          [leftLabelColor]="'--secondary-text'"
          [labelLeft]="'HARDSHIP_DETAILS_HARDSHIP_TYPE' | translate"
          [labelRight]="hardshipService.payload()?.config.event | translate"
        >
        </bw-cell-legacy>
        <bw-cell-legacy
          [leftLabelColor]="'--secondary-text'"
          [labelLeft]="'HARDSHIP_DETAILS_AMOUNT_REQUESTED' | translate"
          [labelRight]="hardshipService.payload()?.amountRequested | currency"
        >
        </bw-cell-legacy>
        @if (!isSubmitStep) {
          <bw-cell-legacy
            [leftLabelColor]="'--secondary-text'"
            [labelLeft]="'HARDSHIP_DETAILS_REQUEST_STATUS' | translate"
            [labelRight]=" hardshipDetailsViews[activeView()].statusKey ?? '' | uppercase | translate"
          >
          </bw-cell-legacy>
        } @else {
          <bw-cell-legacy
            [leftLabelColor]="'--secondary-text'"
            [labelLeft]="'HARDSHIP_DETAILS_DOCUMENTS' | translate"
            [labelRight]="submissionLabelRight()"
          >
          </bw-cell-legacy>
        }
      </section>
    </div>
    @if (isSubmitStep) {
      <div footer-top class="flex-row space-center">
        <form [formGroup]="confirmDataForm">
          <bw-checkbox-legacy [formControlName]="'confirmCheckbox'">
            <typography-legacy text-medium color="var(--primary-text)">
              {{ 'HARDSHIP_SUBMIT_APPLICATION_ACKNOWLEDGMENT' | translate }}
            </typography-legacy>
          </bw-checkbox-legacy>
        </form>
      </div>
    }
    <div footer-actions>
      @if (!isSubmitStep) {
      <button bw-button-legacy [brightsideWebFb]="{ event_name: eventName }"
              (click)="hardshipDetailsViews[activeView()].ctaAction()">
        {{ hardshipDetailsViews[activeView()].ctaKey | uppercase | translate }}
      </button>
        @if (hardshipDetailsViews[activeView()].secondaryCtaKey && hardshipDetailsViews[activeView()].secondaryAction) {
          <button
            bw-link-button-legacy
            (click)="hardshipDetailsViews[activeView()]?.secondaryAction()"
            [brightsideWebFb]="{ event_name: eventName }"
            [secondaryCta]="true">
            {{ hardshipDetailsViews[activeView()]?.secondaryCtaKey | uppercase | translate }}
          </button>
        }
      } @else  {
        <button
          [processing]="processing()"
          [disabled]="confirmDataForm.invalid || processing()"
          bw-button-legacy [brightsideWebFb]="{ event_name: eventName }"
                (click)="hardshipDetailsViews[activeView()].ctaAction()">
          {{ hardshipDetailsViews[activeView()].ctaKey | uppercase | translate }}
        </button>
      }
    </div>
  </bw-action-article-legacy>
} @else {
  <bw-spinner-legacy></bw-spinner-legacy>
}
